<template>
    <div>
        <div class="row mt-2 align-items-center">
            <div class="col-12 col-sm-7">
                <h6 class="font-weight-bold no-wrap mb-0">Select a template</h6>
            </div>
            <div class="col-12 col-sm-5">
                <modal-import-search @search-text-change="updateSearchText" />
            </div>
        </div>
        <modal-import-list class="mt-2 mb-4" :items="items" :is-loading="isLoading" @item-selected="itemSelected" />

        <b-pagination
            v-model="currentPage"
            :total-rows="totalTemplates"
            :per-page="perPage"
            aria-controls="my-table"
            align="center"
        />
    </div>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref, watch } from 'vue';
import store from '@/store';
import ModalImportSearch from '../../search/ModalImportSearch.vue';
import ModalImportList from '../../list/ModalImportList.vue';
import { Item } from '../../../types';

const emit = defineEmits<{
    (event: 'template-selected'): void;
}>();

const isLoading = ref(true);
const currentPage = ref(1);
const perPage = 5;
const searchText = ref('');

const templates = computed(() => store.state.storeLayersModal!.templates);
const totalTemplates = computed(() => store.state.storeLayersModal!.totalTemplates);

const items = computed(() => {
    return templates.value.map((template) => ({
        thumb: template.thumbnailPath,
        name: template.name,
        id: template.id
    }));
});

watch(currentPage, () => {
    fetchTemplates();
});

onMounted(() => {
    fetchTemplates();
});

const updateSearchText = async (value: string) => {
    searchText.value = value;
    await fetchTemplates();
};

const fetchTemplates = async () => {
    try {
        isLoading.value = true;
        await store.dispatch('storeLayersModal/getTemplates', {
            from: (currentPage.value - 1) * perPage,
            to: perPage,
            sortMode: 'ASC',
            sortBy: 'ModifiedDate',
            searchString: searchText.value,
            deleted: false
        });
    } finally {
        isLoading.value = false;
    }
};

const itemSelected = async (item: Item) => {
    try {
        isLoading.value = true;
        const template = templates.value.find((template) => template.id === item.id);
        if (template) {
            await store.dispatch('storeLayersModal/getTemplate', template.id);
            store.dispatch('storeLayersModal/setSelectedItem', item);
            emit('template-selected');
        }
    } finally {
        isLoading.value = false;
    }
};
</script>
